import { StoredSignedDocumentPage } from "src/app/storage/models/stored-orders/stored-signed-document-page";

/**
 * An instance of the StoredSignedDocumentPage model to be used for schema validation
 */
export const storedSignedDocumentPageInstance: StoredSignedDocumentPage = {
	DocumentInformation: {
		LegacyId: 0,
		Page: 0,
		FileName: ""
	},
	SignedDocumentPageImage: ""
}